import { validations } from "utils/validations";
import { Inputs } from "./types";

export const getInputErrors = (inputs: Inputs) => {
    let flag = false;

    const errors = { ...inputs };

    Object.keys(inputs).forEach((inputKey) => {
        const error = validations(
            inputKey,
            inputs[inputKey as keyof typeof inputs],
            true
        );

        if (error !== "") {
            flag = true;
        }

        errors[inputKey as keyof typeof inputs] = error;
    });

    return {
        hasError: flag,
        errors,
    };
};
